import { Icons } from '@cast/design-system';

import {
  AgentSetupBlock,
  AgentSetupBlockProps,
} from './_components/AgentSetupBlock';
import FeatureLabel from './_components/FeatureLabel';

type SetupProps = Pick<AgentSetupBlockProps, 'checked' | 'readonly'>;

const Icon = () => <Icons.CastApa variant="preset" weight="light" />;

const heading = 'Application Performance Automation (APA)';

export const AgentApaSetup = (props: SetupProps) => {
  return (
    <AgentSetupBlock
      heading={heading}
      description="Detects issues, takes actions, and reduces costs and downtime - so you can focus on building and innovating."
      icon={<Icon />}
      labelChip={<FeatureLabel type="premium" />}
      testId="agent-apa"
      {...props}
    />
  );
};
